import React from 'react';

import './domain-search-results.scss';

/**
 * Renders the provided search results.
 */
export const DomainSearchResults = ({ items }) =>
  items && (
    <ul className="domain-list">
      {items.map((item, index) => (
        <li className="domain-list__item" key={index}>
          <a
            className="domain-list__link"
            href={item.url}
            data-referrer-track="srg_override_mod1=cms_result&srg_override_mod2=search_result&srg_override_mod3=landingpage">
            <div role="text">
              <div className="domain-list__kicker">{item.portal.name}</div>
              <div className="domain-list__title">{item.title}</div>
            </div>
            <span className="domain-list__icon" />
          </a>
        </li>
      ))}
    </ul>
  );

export default DomainSearchResults;
